<template>
    <div style="width: 100%; height: 600px">
        <div style="width: 50%; height: 100%; display: inline-block">
            <textarea v-model="json" style="width: 100%; height: 50%; overflow: scroll"/>
            <div class="scroll" style="width: 100%; height: 50%; overflow: scroll">
                <json-viewer :value="parsedJson"></json-viewer>
            </div>
        </div>
        <div style="width: 50%; height: 100%; display: inline-block; border: 1px solid black; vertical-align: top">
            <div v-for="(metadataList, key) in parsedJson">
                {{key}}
                <metadata-component :metadata-list="metadataList" @change="onMetadataComponentEvent" :editable="editable"></metadata-component>
            </div>
        </div>


        <label class="b-checkbox checkbox"><input v-model="editable" type="checkbox" > <span class="check"></span> <span class="control-label"><span >Editable</span>
                                                        <div  class="field has-text-left"> <div class="control is-clearfix"> </div> </div></span></label>



    </div>

</template>

<script>
    import JsonViewer from "vue-json-viewer";
    import {Component, Vue, Watch} from "vue-property-decorator";
    import MetadataComponent from "@/valchrom/common/metadata/MetadataComponent";


    @Component({
        components: {
            MetadataComponent,
            JsonViewer

        }
    })
    export default class TestPage extends Vue {
        editable = true;
        json = "{\n" +
            "    \"CAL_BLANKS\": [\n" +
            "        {\n" +
            "            \"type\": \"CalibrationMultiplier\",\n" +
            "            \"LODMultiplier\": 3.3,\n" +
            "            \"LOQMultiplier\": 10.0\n" +
            "        }\n" +
            "    ],\n" +
            "    \"CAL_Y\": [\n" +
            "        {\n" +
            "            \"type\": \"CalibrationMultiplier\",\n" +
            "            \"LODMultiplier\": 3.3,\n" +
            "            \"LOQMultiplier\": 10.0\n" +
            "        }\n" +
            "    ],\n" +
            "    \"SD_6SPIKE\": [\n" +
            "        {\n" +
            "            \"type\": \"Spiking\",\n" +
            "            \"nB\": 0.0,\n" +
            "            \"kQ\": 10.0,\n" +
            "            \"n\": 1.0\n" +
            "        }\n" +
            "    ],\n" +
            "    \"CCA_CCB_HETERO\": [\n" +
            "        {\n" +
            "            \"type\": \"AlfaBeta\",\n" +
            "            \"alphaBeta\": 0.05,\n" +
            "            \"k\": 2.0\n" +
            "        }\n" +
            "    ],\n" +
            "    \"CCA_CCB_HOMO\": [\n" +
            "        {\n" +
            "            \"type\": \"AlfaBeta\",\n" +
            "            \"alphaBeta\": 0.05,\n" +
            "            \"k\": 2.0\n" +
            "        }\n" +
            "    ],\n" +
            "    \"CAL_RES\": [\n" +
            "        {\n" +
            "            \"type\": \"CalibrationMultiplier\",\n" +
            "            \"LODMultiplier\": 3.3,\n" +
            "            \"LOQMultiplier\": 10.0\n" +
            "        }\n" +
            "    ]\n" +
            "}";

        parsedJson = 1;

        mounted(){
            this.onJsonChanged()
        }

        @Watch("json")
        onJsonChanged() {
            this.parsedJson = JSON.parse(this.json);
        }

        onMetadataComponentEvent() {
            this.json = JSON.stringify(this.parsedJson)
        }

    }
</script>
<style>
    .scroll::-webkit-scrollbar, textarea::-webkit-scrollbar {
        width: 1em;
    }

    .scroll::-webkit-scrollbar-track, textarea::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    }

    .scroll::-webkit-scrollbar-thumb, textarea::-webkit-scrollbar-thumb {
      background-color: darkgrey;
      outline: 1px solid slategrey;
    }
</style>